import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { PreviewUploadImageComponent } from '@components/preview-upload-image/preview-upload-image.component';
import { environment } from '@environments/environment';
import { AntecedenteService } from '@services/antecedente.service';
import { ToastService } from '@utils/toast.service';
import { requiredFileType, requiredFileSize } from '@utils/validators';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-no-penal',
  imports: [
    CommonModule,
    BackboneComponent,
    BreadcrumbComponent,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    InputTextModule,
    ButtonModule,
    InputSwitchModule,
    PreviewUploadImageComponent,
    SelectButtonModule,
    IconFieldModule,
    InputIconModule,
    InputGroupAddonModule,
    InputGroup,
    TooltipModule,
  ],
  templateUrl: './no-penal.component.html',
  styleUrl: './no-penal.component.scss',
})
export class NoPenalPage {
  private formBuilder = inject(FormBuilder);
  private toastService = inject(ToastService);
  private antecedenteService = inject(AntecedenteService);

  public apiUrl = environment.app.apiUrl;
  public maxSizesUpload = 3000000;
  public isSaving = false;

  public list: any = [];
  public fingerprintOptions: any[] = [
    { label: 'Sin huella', value: false },
    { label: 'Con huella', value: true },
  ];
  public searchValue: string | undefined;

  public formUpload = this.formBuilder.group({
    name: [null, Validators.required],
    photo: [null, [Validators.required, requiredFileType(['png', 'jpg', 'jpeg']), requiredFileSize(this.maxSizesUpload)]],
    fingerprint: [true, Validators.required],
  });

  get name() {
    return this.formUpload.get('name');
  }
  set name(value: any) {
    this.name.setValue(value);
  }
  get photo() {
    return this.formUpload.get('photo');
  }
  set photo(value: any) {
    this.photo.setValue(value);
  }
  get fingerprint() {
    return this.formUpload.get('fingerprint');
  }
  set fingerprint(value: any) {
    this.fingerprint.setValue(value);
  }

  public onPhotoChanged = (event: any) => {
    if (event.target.files && event.target.files.length) {
      this.photo = event.target.files[0];
    }
  };

  async ngOnInit() {
    await this.refresh();
  }

  refresh = async () => {
    await this.antecedenteService.listNoPenal().then((response) => (this.list = response));
  };

  generate = async () => {
    this.isSaving = true;

    const myFormData = new FormData();

    myFormData.append('name', this.name.value);
    myFormData.append('photo', this.photo.value);
    myFormData.append('fingerprint', this.fingerprint.value);

    await this.antecedenteService
      .generateNoPenal(myFormData)
      .then(() => {
        this.toastService.success('Constancia generada.');
        location.reload();
      })
      .catch((err) => {
        this.toastService.error(err.error.data.message || 'Error al generar la constancia.');
      });

    this.isSaving = false;
  };
}
